<script>import Action from '../Action/Action.svelte';
export let variant = 'button';
export let colorMode = undefined;
export let size = 'regular';
export let disabled = false;
export let altText = '';
export let balanced = false;
export let onClick = undefined;
export let modal = undefined;
export let noArrow = false;
export let preventOrphanIcon = false;
export let text = '';
</script>

<Action
  {...$$restProps}
  as="button"
  class="Button {$$restProps.class || ''}"
  {variant}
  {colorMode}
  {size}
  {disabled}
  {altText}
  {balanced}
  {onClick}
  {modal}
  {noArrow}
  {preventOrphanIcon}
  {text}
/>
